import { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

const STATUS = { paid: "default", partial: "secondary", pending: "outline" };

export default function AgentSales() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get(`/agent/sales?month=${month}`).then((r) => setData(r.data));
  }, [month]);

  if (!data) return <div className="flex justify-center py-24"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  const m = (v) => money(v, data.currency, data.symbol);

  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight">My sales</h1>
          <p className="text-sm text-muted-foreground">Invoice-wise · commission counts only when paid in full</p>
        </div>
        <Input type="month" className="w-36 h-9" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="agent-sales-month" />
      </div>
      {data.sales.length === 0 ? (
        <p className="text-sm text-muted-foreground py-12 text-center">No sales this period.</p>
      ) : (
        <div className="space-y-3">
          {data.sales.map((s, i) => (
            <Card key={i} className="p-4" data-testid={`sale-row-${i}`}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-mono text-[11px] text-muted-foreground">{s.invoice_no}</p>
                  <p className="font-medium text-sm">{s.product}</p>
                  <p className="text-xs text-muted-foreground">{s.customer} · {s.date}{s.due_date && s.payment_status !== "paid" && ` · due ${s.due_date}`}{s.paid_date && ` · paid ${s.paid_date}`}</p>
                </div>
                <Badge variant={s.is_return ? "destructive" : STATUS[s.payment_status]} className="capitalize">
                  {s.is_return ? "Return" : s.payment_status}
                </Badge>
              </div>
              <div className="flex justify-between mt-3 text-sm">
                <span className="text-muted-foreground">{s.qty} bags · {s.discount_level}% off</span>
                <span>{m(s.sale_value)}</span>
              </div>
              <div className="flex justify-between mt-1 text-sm">
                <span className="text-muted-foreground">Your commission{s.commission_void && " (voided)"}</span>
                <span className="font-semibold text-primary">{m(s.commission)}{s.above_bonus > 0 && <span className="text-xs text-accent-foreground"> +{m(s.above_bonus)} above-list</span>}</span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
